import { initUserInfo, IUserInfo } from "@/types/userInfo";
import { FeatureType, SceneType } from "@/types/abstract";


export const castTypeArray = {
    Premium: "プレミアム",
    Standard: "スタンダード",
    Economy: "エコノミー",
    None: ""
} as const;
export type castType = typeof castTypeArray[keyof typeof castTypeArray];

// キャスト向けのタイプの名称
export const castTypeArrayForCast = {
    Platinum: "プラチナ",
    Gold: "ゴールド",
    Standard: "スタンダード",
    None: ""
} as const;

export interface ICastType {
    castType: castType
}

export function convertCastTypeForCast(castType: castType): string{
    if(castType == castTypeArray.Premium){
        return castTypeArrayForCast.Platinum
    }
    if(castType == castTypeArray.Standard){
        return castTypeArrayForCast.Gold
    }
    if(castType == castTypeArray.Economy){
        return castTypeArrayForCast.Standard
    }
    return castTypeArrayForCast.None
}

export interface ICast extends IUserInfo {
    freePlanFee: number;
    castType: castType;
    sceneTag: SceneType[];
    featureTag: FeatureType[];
    isApproval: boolean;
}

export const initCast: ICast = Object.assign(initUserInfo, {
    freePlanFee: 5000,
    castType: castTypeArray.Economy,
    sceneTag: [],
    featureTag: [],
    isApproval: false
});

// キャスト給与情報
export interface ICastPayment {
    paymentId: string;
    transferDate: string;
    eventDate: string;
    eventStartTime: string;
    eventEndTime: string;
    eventUsageTime: number;
    eventPaymentPoint: number;
    isTransfered: boolean;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function isICast(data:any): data is ICast{
    return data.castType !== undefined 
}

// キャストカードサイズ
export const castCardSize = {
    Standard: "standard",
    Mini: "mini"
} as const;
export type castCardSizeType = typeof castCardSize[keyof typeof castCardSize];